import { getProgressPercent } from '@mimir/client-common/fileSync';
import type { OngoingDownload, OngoingDownloadStatus } from '@mimir/client-common/model/ongoingDownload';
import { TransferStateDto } from '@mimir/common/dto/transferRequestDtos';

/**
 * Gets simplified download progress from transfer request object
 * @param transferRequest - Object of TransferRequest
 * @returns Object with progress percentage and initialization status
 */
export const getSanitizedDownloadProgress = (transferRequest: OngoingDownload | null): OngoingDownloadStatus => {
  const downloadStatus: OngoingDownloadStatus = {
    initiated: false,
    percent: 0,
  };

  if (transferRequest && transferRequest.transferState !== TransferStateDto.ERROR) {
    downloadStatus.state = transferRequest.transferState;
    downloadStatus.restoring = transferRequest.highresIsOffline;
    downloadStatus.initiated = !transferRequest.highresIsOffline;

    const { downloadProgress } = transferRequest;
    if (downloadProgress) {
      downloadStatus.percent = getProgressPercent(transferRequest);
    } else {
      downloadStatus.percent = 0;
    }
  }
  return downloadStatus;
};
